import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled, { CSSProp } from 'styled-components';

export const WrapperStyled = styled.div<{ $hasFile: boolean }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  box-sizing: border-box;
  min-height: ${({ $hasFile }): CSSProp => ($hasFile ? '5.8rem' : '12rem')};
  margin-bottom: 5rem;
  padding: 2rem 3rem 2rem 2rem;
  border-radius: 10px;
  background-color: ${colors.neutral.white};
`;

export const FileButtonStyled = styled(Button)`
  ${typography.bold[16]}
  padding:0;
  text-align: left;

  ${breakpointsMQ4.sm.down} {
    display: inline-block;
    max-width: 30rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const NoDataLabelSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.5rem;
`;

export const NoDataTitleStyled = styled.h3`
  ${typography.bold[18]}
  color: ${colors.neutral[700]};
  margin: 0;
  text-align: center;
`;

export const NoDataSubtitleStyled = styled.p`
  ${typography.regular[16]}
  color: ${colors.neutral[500]};
  margin: 0;
  text-align: center;
`;
